import React from 'react'
import {
  TotalSleepTime,
  PeriodInBed,
  Content,
  Hour,
  HourUnit,
  HourValue,
  Minute,
  MinuteUnit,
  MinuteValue
} from './styles'
import { BehaviorCard } from '~/components/behaviors/BehaviorCard'
import { transformDate } from '~/utils'
import { IBehavior } from '~/interfaces'

interface IProps {
  behavior: IBehavior | undefined
}

const HOUR_UNIT = 'h'
const MINUTE_UNIT = 'min'

export const Sleep = ({ behavior }: IProps): JSX.Element => {
  if (!behavior) return <></>
  if (behavior.type !== 'Sono') return <></>

  const { type, startDate, endDate, properties } = behavior

  const datetimeLastUpdate = transformDate({ date: endDate, withHourAndMinute: false, dateFormat: 'dd/MM HH:mm' })

  const totalSleepTime = properties.find(p => p.type === 'Duração')?.value ?? ''

  const hourPartFromTotalSleepTime = totalSleepTime?.split('h')?.[0]
  const thereIsHourPartFromTotalSleepTime = hourPartFromTotalSleepTime !== ''

  const minutePartFromTotalSleepTime = totalSleepTime?.split('h')?.[1]?.replace(/\D/g, '')
  const thereIsMinutePartFromTotalSleepTime = minutePartFromTotalSleepTime !== ''

  const wentToBed = transformDate({ date: startDate, withHourAndMinute: false, dateFormat: 'dd/MM HH:mm' })
  const wokeUp = transformDate({ date: endDate, withHourAndMinute: false, dateFormat: 'dd/MM HH:mm' })
  const periodInBed = `${wentToBed} - ${wokeUp}`

  return (
    <BehaviorCard title={type} iconName="behaviorSleep" time={datetimeLastUpdate}>
      <Content>
        <TotalSleepTime>
          {thereIsHourPartFromTotalSleepTime && (
            <Hour>
              <HourValue>{hourPartFromTotalSleepTime}</HourValue>
              <HourUnit>{HOUR_UNIT}</HourUnit>
            </Hour>
          )}
          {thereIsMinutePartFromTotalSleepTime && (
            <Minute>
              <MinuteValue>{minutePartFromTotalSleepTime}</MinuteValue>
              <MinuteUnit>{MINUTE_UNIT}</MinuteUnit>
            </Minute>
          )}
        </TotalSleepTime>
        <PeriodInBed>{periodInBed}</PeriodInBed>
      </Content>
    </BehaviorCard>
  )
}
